import React from 'react'

import DealOwnerField, {
    formatBareName,
    useDealershipUsersWithUsername,
} from 'components/DealOwnerField'
import { ErrorMessage } from 'components/FormikFields/FormikDropdown/FormikDropdown.styled'

import { FieldConfigBase, FieldProps } from '../../containers/FormBuilder'

interface FinanceManagerSelectFieldConfig extends FieldConfigBase {
    label: string
    disabled?: boolean
}

export default function FinanceManagerSelectField(
    props: FieldProps<FinanceManagerSelectFieldConfig>,
) {
    const { fieldName, fieldKit, fieldConfig } = props
    const value: string = (fieldKit.values[fieldName] as string) || ''
    const touched = fieldKit.touched[fieldName]
    const error = fieldKit.errors[fieldName]

    const {
        users,
        loading,
        error: usersError,
        retry,
    } = useDealershipUsersWithUsername()

    // finance_manager is stored as a plain string; userId is unused here.
    const handleSelect = (newValue: string, _userId: number | null) => {
        fieldKit.setFieldTouched(fieldName, true)
        fieldKit.setFieldValue(fieldName, newValue)
    }

    return (
        <div data-testid={`${fieldName}-finance-manager-select`}>
            <DealOwnerField
                value={value}
                users={users}
                disabled={fieldConfig.disabled}
                onSave={handleSelect}
                label={fieldConfig.label}
                helperText=""
                layout="vertical"
                size="full"
                writeInEnabled={false}
                formatOption={formatBareName}
                loading={loading}
                error={usersError}
                onRetry={retry}
            />
            {touched && error && <ErrorMessage>{error}</ErrorMessage>}
        </div>
    )
}
